export default __webpack_public_path__ + "static/media/landing-page.0c37d16e.svg";